/**
 * Creado por Norte70
 * @author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 30/10/2020
 */

const procedureInCartRequest = () => {
    return {
        procedure_id: 0,
        stage_id: 0,
        field_id: 0
    }
}

export default procedureInCartRequest;